<template>
  <div class="options-bg">
    <div class="navBtn" v-for="(item, index) in titles" :key="index">
      <CButton
        :selected="index == currentIndex"
        :title="item.title"
        @click="onClickBtn(item, index)"
      ></CButton>
    </div>
  </div>
</template>

<script>
import CButton from "./CButtom.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    titles: {
      type: Array,
      required: true,
    },
  },
  components: { CButton },
  computed: { ...mapGetters(["vrbase", "userInfo"]) },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    onClickBtn(item, index) {
      if (
        (this.userInfo.type == 3 ||this.userInfo.type == 4) &&
        this.userInfo.is_authority == 0 &&
        [1, 2].includes(index)
      ) {
        this.$message.error(this.$t('edit.editMessage.permission'));
      } else {
        this.currentIndex = index;
        this.$emit("onClick", item);
      }
    },
  },
};
</script>

<style scoped>
.options-bg {
  width: 88px;
  height: 100%;
  background-color: #333;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
}
.navBtn {
  height: 58px;
  width: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 4px */
</style>